import analog_clock_widget from '@/assets/images/widget/analog_clock.png';
import digital_clock_widget from '@/assets/images/widget/digital_clock.png';
import mpk_1_widget from '@/assets/images/widget/mpk_1.png';
import mpk_2_widget from '@/assets/images/widget/mpk_2.png';
import mpk_3_widget from '@/assets/images/widget/mpk_3.png';
import mpk_page_widget from '@/assets/images/widget/mpk_page.png';
import status_widget from '@/assets/images/widget/status.png';
import weather_widget from '@/assets/images/widget/weather.png';
import status_2_widget from '@/assets/images/widget/status_2.png';
import call_forward from '@/assets/images/widget/call_forward.png';
import multicast_listening from '@/assets/images/widget/multicast_listening.png';

import analog_clock_widget_mini from '@/assets/images/widget/analog_clock_mini.png';
import digital_clock_widget_mini from '@/assets/images/widget/digital_clock_mini.png';
import mpk_1_widget_mini from '@/assets/images/widget/mpk_1_mini.png';
import mpk_2_widget_mini from '@/assets/images/widget/mpk_2_mini.png';
import mpk_3_widget_mini from '@/assets/images/widget/mpk_3_mini.png';
import mpk_page_widget_mini from '@/assets/images/widget/mpk_page_mini.png';
import status_widget_mini from '@/assets/images/widget/status_mini.png';
import weather_widget_mini from '@/assets/images/widget/weather_mini.png';
import status_2_widget_mini from '@/assets/images/widget/status_2_mini.png';
import call_forward_mini from '@/assets/images/widget/call_forward_mini.png';
import multicast_listening_mini from '@/assets/images/widget/multicast_listening_mini.png';

const DEFAULT_WIDGET_ITEMS = {
  // 可编程键
  'com.base.module.mpk.ui.widget.MPKWidget': {
    className: 'com.base.module.mpk.ui.widget.MPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_1_widget,
    imgMini: mpk_1_widget_mini,
    title: 'MPK',
    size: { w: 2, h: 4 },
  },
  'com.base.module.mpk.ui.widget.TwoMPKWidget': {
    className: 'com.base.module.mpk.ui.widget.TwoMPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_2_widget,
    imgMini: mpk_2_widget_mini,
    title: 'MPK',
    size: { w: 3, h: 4 },
  },
  'com.base.module.mpk.ui.widget.ThreeMPKWidget': {
    className: 'com.base.module.mpk.ui.widget.ThreeMPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_3_widget,
    imgMini: mpk_3_widget_mini,
    title: 'MPK',
    size: { w: 5, h: 4 },
  },
  'com.base.module.mpk.ui.widget.PageMPKWidget': {
    className: 'com.base.module.mpk.ui.widget.PageMPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_page_widget,
    imgMini: mpk_page_widget_mini,
    title: 'MPK',
    size: { w: 5, h: 4 },
  },
  // 数字时钟
  'com.android.alarmclock.DigitalAppWidgetProvider': {
    className: 'com.android.alarmclock.DigitalAppWidgetProvider',
    packageName: 'com.android.deskclock',
    img: digital_clock_widget,
    imgMini: digital_clock_widget_mini,
    title: 'DIGIT_CLOCK',
    size: { w: 2, h: 1 },
  },
  // 天气预报
  'com.base.module.weather.widget.WeatherBaseWidget': {
    className: 'com.base.module.weather.widget.WeatherBaseWidget',
    packageName: 'com.base.module.weather',
    img: weather_widget,
    imgMini: weather_widget_mini,
    title: 'WEATHER',
    size: { w: 3, h: 3 },
  },
  // 指针时钟
  'com.android.alarmclock.AnalogAppWidgetProvider': {
    className: 'com.android.alarmclock.AnalogAppWidgetProvider',
    packageName: 'com.android.deskclock',
    img: analog_clock_widget,
    imgMini: analog_clock_widget_mini,
    title: 'ANALOG_CLOCKS',
    size: { w: 1, h: 1 },
  },
  // 系统状态
  'com.android.settings.gs.widget.IPWidget': {
    className: 'com.android.settings.gs.widget.IPWidget',
    packageName: 'com.android.settings',
    img: status_widget,
    imgMini: status_widget_mini,
    title: 'IP_WIDGET',
    size: { w: 3, h: 2 },
  },
};

const GXV3350_WIDGET_ITEMS = {
  // 可编程键
  'com.base.module.mpk.ui.widget.MPKWidget': {
    className: 'com.base.module.mpk.ui.widget.MPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_1_widget,
    imgMini: mpk_1_widget_mini,
    title: 'MPK',
    size: { w: 2, h: 3 },
  },
  'com.base.module.mpk.ui.widget.TwoMPKWidget': {
    className: 'com.base.module.mpk.ui.widget.TwoMPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_2_widget,
    imgMini: mpk_2_widget_mini,
    title: 'MPK',
    size: { w: 3, h: 3 },
  },
  'com.base.module.mpk.ui.widget.ThreeMPKWidget': {
    className: 'com.base.module.mpk.ui.widget.ThreeMPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_3_widget,
    imgMini: mpk_3_widget_mini,
    title: 'MPK',
    size: { w: 5, h: 3 },
  },
  'com.base.module.mpk.ui.widget.PageMPKWidget': {
    className: 'com.base.module.mpk.ui.widget.PageMPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_page_widget,
    imgMini: mpk_page_widget_mini,
    title: 'MPK',
    size: { w: 5, h: 3 },
  },
  // 数字时钟
  'com.android.alarmclock.DigitalAppWidgetProvider': {
    className: 'com.android.alarmclock.DigitalAppWidgetProvider',
    packageName: 'com.android.deskclock',
    img: digital_clock_widget,
    imgMini: digital_clock_widget_mini,
    title: 'DIGIT_CLOCK',
    size: { w: 2, h: 1 },
  },
  // 天气预报
  'com.base.module.weather.widget.WeatherBaseWidget': {
    className: 'com.base.module.weather.widget.WeatherBaseWidget',
    packageName: 'com.base.module.weather',
    img: weather_widget,
    imgMini: weather_widget_mini,
    title: 'WEATHER',
    size: { w: 3, h: 3 },
  },
  // 指针时钟
  'com.android.alarmclock.AnalogAppWidgetProvider': {
    className: 'com.android.alarmclock.AnalogAppWidgetProvider',
    packageName: 'com.android.deskclock',
    img: analog_clock_widget,
    imgMini: analog_clock_widget_mini,
    title: 'ANALOG_CLOCKS',
    size: { w: 1, h: 1 },
  },
  // 系统状态
  'com.android.settings.gs.widget.IPWidget': {
    className: 'com.android.settings.gs.widget.IPWidget',
    packageName: 'com.android.settings',
    img: status_widget,
    imgMini: status_widget_mini,
    title: 'IP_WIDGET',
    size: { w: 3, h: 2 },
  },
};

const GXV3470_WIDGET_ITEMS = {
  // 可编程键
  'com.base.module.mpk.ui.widget.MPKWidget': {
    className: 'com.base.module.mpk.ui.widget.MPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_1_widget,
    imgMini: mpk_1_widget_mini,
    title: 'MPK',
    size: { w: 2, h: 4 },
  },
  'com.base.module.mpk.ui.widget.TwoMPKWidget': {
    className: 'com.base.module.mpk.ui.widget.TwoMPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_2_widget,
    imgMini: mpk_2_widget_mini,
    title: 'MPK',
    size: { w: 3, h: 4 },
  },
  'com.base.module.mpk.ui.widget.ThreeMPKWidget': {
    className: 'com.base.module.mpk.ui.widget.ThreeMPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_3_widget,
    imgMini: mpk_3_widget_mini,
    title: 'MPK',
    size: { w: 4, h: 4 },
  },
  'com.base.module.mpk.ui.widget.PageMPKWidget': {
    className: 'com.base.module.mpk.ui.widget.PageMPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_page_widget,
    imgMini: mpk_page_widget_mini,
    title: 'MPK',
    size: { w: 4, h: 4 },
  },
  // 数字时钟
  'com.android.alarmclock.DigitalAppWidgetProvider': {
    className: 'com.android.alarmclock.DigitalAppWidgetProvider',
    packageName: 'com.android.deskclock',
    img: digital_clock_widget,
    imgMini: digital_clock_widget_mini,
    title: 'DIGIT_CLOCK',
    size: { w: 2, h: 1 },
  },
  // 指针时钟
  'com.android.alarmclock.AnalogAppWidgetProvider': {
    className: 'com.android.alarmclock.AnalogAppWidgetProvider',
    packageName: 'com.android.deskclock',
    img: analog_clock_widget,
    imgMini: analog_clock_widget_mini,
    title: 'ANALOG_CLOCKS',
    size: { w: 1, h: 1 },
  },
  // 系统状态 (2 * 2, GXV3470特有)
  'com.android.settings.gs.widget.IPWidget': {
    className: 'com.android.settings.gs.widget.IPWidget',
    packageName: 'com.android.settings',
    img: status_2_widget,
    imgMini: status_2_widget_mini,
    title: 'IP_WIDGET',
    size: { w: 2, h: 2 },
  },
  // Call Forward Settings
  'com.android.settings.gs.widget.CallForwardWidget': {
    className: 'com.android.settings.gs.widget.CallForwardWidget',
    packageName: 'com.android.settings',
    img: call_forward,
    imgMini: call_forward_mini,
    title: 'CALL_FORWARD',
    size: { w: 1, h: 1 },
  },
  // Multicast Listening
  'com.base.module.mpk.ui.widget.MulticastWidget': {
    className: 'com.base.module.mpk.ui.widget.MulticastWidget',
    packageName: 'com.base.module.mpk',
    img: multicast_listening,
    imgMini: multicast_listening_mini,
    title: 'MULTICAST_LISTENING',
    size: { w: 2, h: 2 },
  },
};

const GXV3450_WIDGET_ITEMS = {
  // 可编程键
  'com.base.module.mpk.ui.widget.MPKWidget': {
    className: 'com.base.module.mpk.ui.widget.MPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_1_widget,
    imgMini: mpk_1_widget_mini,
    title: 'MPK',
    size: { w: 2, h: 3 },
  },
  'com.base.module.mpk.ui.widget.TwoMPKWidget': {
    className: 'com.base.module.mpk.ui.widget.TwoMPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_2_widget,
    imgMini: mpk_2_widget_mini,
    title: 'MPK',
    size: { w: 3, h: 3 },
  },
  'com.base.module.mpk.ui.widget.ThreeMPKWidget': {
    className: 'com.base.module.mpk.ui.widget.ThreeMPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_3_widget,
    imgMini: mpk_3_widget_mini,
    title: 'MPK',
    size: { w: 5, h: 3 },
  },
  'com.base.module.mpk.ui.widget.PageMPKWidget': {
    className: 'com.base.module.mpk.ui.widget.PageMPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_page_widget,
    imgMini: mpk_page_widget_mini,
    title: 'MPK',
    size: { w: 5, h: 3 },
  },
  // 数字时钟
  'com.android.alarmclock.DigitalAppWidgetProvider': {
    className: 'com.android.alarmclock.DigitalAppWidgetProvider',
    packageName: 'com.android.deskclock',
    img: digital_clock_widget,
    imgMini: digital_clock_widget_mini,
    title: 'DIGIT_CLOCK',
    size: { w: 2, h: 1 },
  },
  // 指针时钟
  'com.android.alarmclock.AnalogAppWidgetProvider': {
    className: 'com.android.alarmclock.AnalogAppWidgetProvider',
    packageName: 'com.android.deskclock',
    img: analog_clock_widget,
    imgMini: analog_clock_widget_mini,
    title: 'ANALOG_CLOCKS',
    size: { w: 1, h: 1 },
  },
  // 系统状态
  'com.android.settings.gs.widget.IPWidget': {
    className: 'com.android.settings.gs.widget.IPWidget',
    packageName: 'com.android.settings',
    img: status_widget,
    imgMini: status_widget_mini,
    title: 'IP_WIDGET',
    size: { w: 3, h: 2 },
  },
  // Call Forward Settings
  'com.android.settings.gs.widget.CallForwardWidget': {
    className: 'com.android.settings.gs.widget.CallForwardWidget',
    packageName: 'com.android.settings',
    img: call_forward,
    imgMini: call_forward_mini,
    title: 'CALL_FORWARD',
    size: { w: 1, h: 1 },
  },
  // Multicast Listening
  'com.base.module.mpk.ui.widget.MulticastWidget': {
    className: 'com.base.module.mpk.ui.widget.MulticastWidget',
    packageName: 'com.base.module.mpk',
    img: multicast_listening,
    imgMini: multicast_listening_mini,
    title: 'MULTICAST_LISTENING',
    size: { w: 2, h: 2 },
  },
};

const GXV3480_WIDGET_ITEMS = {
  // 可编程键
  'com.base.module.mpk.ui.widget.MPKWidget': {
    className: 'com.base.module.mpk.ui.widget.MPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_1_widget,
    imgMini: mpk_1_widget_mini,
    title: 'MPK',
    size: { w: 2, h: 4 },
  },
  'com.base.module.mpk.ui.widget.TwoMPKWidget': {
    className: 'com.base.module.mpk.ui.widget.TwoMPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_2_widget,
    imgMini: mpk_2_widget_mini,
    title: 'MPK',
    size: { w: 3, h: 4 },
  },
  'com.base.module.mpk.ui.widget.ThreeMPKWidget': {
    className: 'com.base.module.mpk.ui.widget.ThreeMPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_3_widget,
    imgMini: mpk_3_widget_mini,
    title: 'MPK',
    size: { w: 5, h: 4 },
  },
  'com.base.module.mpk.ui.widget.PageMPKWidget': {
    className: 'com.base.module.mpk.ui.widget.PageMPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_page_widget,
    imgMini: mpk_page_widget_mini,
    title: 'MPK',
    size: { w: 5, h: 4 },
  },
  // 数字时钟
  'com.android.alarmclock.DigitalAppWidgetProvider': {
    className: 'com.android.alarmclock.DigitalAppWidgetProvider',
    packageName: 'com.android.deskclock',
    img: digital_clock_widget,
    imgMini: digital_clock_widget_mini,
    title: 'DIGIT_CLOCK',
    size: { w: 2, h: 1 },
  },
  // 指针时钟
  'com.android.alarmclock.AnalogAppWidgetProvider': {
    className: 'com.android.alarmclock.AnalogAppWidgetProvider',
    packageName: 'com.android.deskclock',
    img: analog_clock_widget,
    imgMini: analog_clock_widget_mini,
    title: 'ANALOG_CLOCKS',
    size: { w: 1, h: 1 },
  },
  // 系统状态
  'com.android.settings.gs.widget.IPWidget': {
    className: 'com.android.settings.gs.widget.IPWidget',
    packageName: 'com.android.settings',
    img: status_widget,
    imgMini: status_widget_mini,
    title: 'IP_WIDGET',
    size: { w: 3, h: 2 },
  },
  // Call Forward Settings
  'com.android.settings.gs.widget.CallForwardWidget': {
    className: 'com.android.settings.gs.widget.CallForwardWidget',
    packageName: 'com.android.settings',
    img: call_forward,
    imgMini: call_forward_mini,
    title: 'CALL_FORWARD',
    size: { w: 1, h: 1 },
  },
  // Multicast Listening
  'com.base.module.mpk.ui.widget.MulticastWidget': {
    className: 'com.base.module.mpk.ui.widget.MulticastWidget',
    packageName: 'com.base.module.mpk',
    img: multicast_listening,
    imgMini: multicast_listening_mini,
    title: 'MULTICAST_LISTENING',
    size: { w: 1, h: 2 },
  },
};

const GAC2570_WIDGET_ITEMS = {
  // 可编程键
  'com.base.module.mpk.ui.widget.MPKWidget': {
    className: 'com.base.module.mpk.ui.widget.MPKWidget',
    packageName: 'com.base.module.mpk',
    img: mpk_1_widget,
    imgMini: mpk_1_widget_mini,
    title: 'MPK',
    size: { w: 1, h: 3 },
  },
  // 'com.base.module.mpk.ui.widget.TwoMPKWidget': {
  //   className: 'com.base.module.mpk.ui.widget.TwoMPKWidget',
  //   packageName: 'com.base.module.mpk',
  //   img: mpk_2_widget,
  //   imgMini: mpk_2_widget_mini,
  //   title: 'MPK',
  //   size: { w: 3, h: 3 },
  // },
  // 'com.base.module.mpk.ui.widget.ThreeMPKWidget': {
  //   className: 'com.base.module.mpk.ui.widget.ThreeMPKWidget',
  //   packageName: 'com.base.module.mpk',
  //   img: mpk_3_widget,
  //   imgMini: mpk_3_widget_mini,
  //   title: 'MPK',
  //   size: { w: 4, h: 3 },
  // },
  // 'com.base.module.mpk.ui.widget.PageMPKWidget': {
  //   className: 'com.base.module.mpk.ui.widget.PageMPKWidget',
  //   packageName: 'com.base.module.mpk',
  //   img: mpk_page_widget,
  //   imgMini: mpk_page_widget_mini,
  //   title: 'MPK',
  //   size: { w: 4, h: 3 },
  // },
  // 数字时钟
  'com.android.alarmclock.DigitalAppWidgetProvider': {
    className: 'com.android.alarmclock.DigitalAppWidgetProvider',
    packageName: 'com.android.deskclock',
    img: digital_clock_widget,
    imgMini: digital_clock_widget_mini,
    title: 'DIGIT_CLOCK',
    size: { w: 1, h: 1 },
  },
};

export default {
  gxv3370: DEFAULT_WIDGET_ITEMS,
  gxv3380: DEFAULT_WIDGET_ITEMS,
  gxv3470: GXV3470_WIDGET_ITEMS,
  gxv3480: GXV3480_WIDGET_ITEMS,
  gxv3350: GXV3350_WIDGET_ITEMS,
  gxv3450: GXV3450_WIDGET_ITEMS,
  gac2570: GAC2570_WIDGET_ITEMS,
};
